import routes from "../services/routes";

export interface HeaderMenuItem {
    /**
     * Display title locale key
     */
    title: string;
    /**
     * Display subtitle locale key
     */
    subtitle?: string;
    /**
     * Route if direct link
     * Use empty string if not direct link for easier typing
     */
    route: string;
    /**
     * Sub-menus if any
     */
    routes?: Record<string, HeaderMenuItem>;
    /**
     * Direct link to pdf
     */
    pdf?: string;
    /**
     * Emoji for mobile menu
     */
    emoji?: string;
}

const headerMenu: Record<string, HeaderMenuItem> = {
    home: {
        title: 'menu.home.title',
        route: routes.home,
        emoji: '🏠',
    },
    tools: {
        title: 'menu.tools.title',
        route: routes.tools,
        emoji: '📱',
        routes: {
            challenge: {
                title: 'menu.tools.challenge.title',
                subtitle: 'menu.tools.challenge.subtitle',
                emoji: '✨',
                route: routes.challenge.home,
            },
            coaching: {
                title: 'menu.tools.coaching.title',
                subtitle: 'menu.tools.coaching.subtitle',
                emoji: '🧑‍🏫',
                route: routes.coaching,
            }
        },
    },
    challenge: {
        title: 'menu.challenge.title',
        subtitle: 'menu.challenge.subtitle',
        route: '',
        emoji: '🎯',
        routes: {
            companies: {
                title: 'menu.challenge.companies.title',
                subtitle: 'menu.challenge.companies.subtitle',
                emoji: '🥇',
                route: routes.challenge.companies,
            },
            internal: {
                title: 'menu.challenge.internal.title',
                subtitle: 'menu.challenge.internal.subtitle',
                emoji: '🏆',
                route: routes.challenge.internal,
            },
            school: {
                title: 'menu.challenge.school.title',
                subtitle: 'menu.challenge.school.subtitle',
                emoji: '🎓',
                route: routes.challenge.school,
            },
            tenant: {
                title: 'menu.challenge.tenant.title',
                subtitle: 'menu.challenge.tenant.subtitle',
                emoji: '🏘️',
                route: routes.challenge.tenant,
            }
        },
    },
    team: {
        title: 'menu.team.title',
        route: routes.team,
        emoji: '🙌',
    },
    resources: {
        title: 'menu.resources.title',
        route: '',
        routes: {
            footprint: {
                title: 'menu.resources.footprint.title',
                subtitle: 'menu.resources.footprint.subtitle',
                emoji: '🌍',
                route: routes.resources.footprint,
            },
            blog: {
                title: 'menu.resources.blog.title',
                subtitle: 'menu.resources.blog.subtitle',
                emoji: '💎',
                route: routes.blog,
            },
            /*
            projectsPot: {
                title: 'menu.resources.projectsPot.title',
                subtitle: 'menu.resources.projectsPot.subtitle',
                emoji: '🌱',
                route: routes.projectsPot,
            },
            */
            quizEcolo: {
                title: 'menu.resources.quizEcolo.title',
                subtitle: 'menu.resources.quizEcolo.subtitle',
                emoji: '👀️',
                route: routes.resources.quizEcolo.home,
            },
            verdi: {
              title: 'menu.resources.verdi.title',
              subtitle: 'menu.resources.verdi.subtitle',
              emoji: '📖',
              pdf: '/pdf/Energic_etude_cas_Verdi.pdf',
              route: '',
            },
            /*
            whiteBook: {
                title: 'menu.resources.whiteBook.title',
                subtitle: 'menu.resources.whiteBook.subtitle',
                emoji: '📖',
                route: routes.resources.whiteBook,
            },
            mobilityWhiteBook: {
                title: 'menu.resources.mobilityWhiteBook.title',
                subtitle: 'menu.resources.mobilityWhiteBook.subtitle',
                emoji: '📖',
                route: routes.resources.mobilityWhiteBook,
            },
            waterWhiteBook: {
                title: 'menu.resources.waterWhiteBook.title',
                subtitle: 'menu.resources.waterWhiteBook.subtitle',
                emoji: '📖',
                route: routes.resources.waterWhiteBook,
            },
            pinkOctoberBooklet: {
                title: 'menu.resources.pinkOctoberBooklet.title',
                subtitle: 'menu.resources.pinkOctoberBooklet.subtitle',
                emoji: '💝',
                route: routes.resources.pinkOctoberBooklet,
            },
             */
            newsletter: {
                title: 'menu.resources.newsletter.title',
                subtitle: 'menu.resources.newsletter.subtitle',
                emoji: '📰',
                route: routes.resources.newsletter,
            },
        },
        emoji: '📘',
    },
    mySpace: {
        title: 'menu.mySpace.title',
        route: '',
        routes: {
            webapp: {
                title: 'menu.mySpace.webapp.title',
                subtitle: 'menu.mySpace.webapp.subtitle',
                emoji: '💻',
                route: routes.mySpace.webapp,
            },
            dashboard: {
                title: 'menu.mySpace.dashboard.title',
                subtitle: 'menu.mySpace.dashboard.subtitle',
                emoji: '🖥️',
                route: routes.mySpace.dashboard,
            },
        },
        emoji: '🤗',
    },
    contact: {
        title: 'menu.contact.title',
        route: routes.contact.root,
        emoji: '💌',
    }
};

export default headerMenu;